import { Pagination } from "@mui/material";
import { styled } from "@mui/material/styles";
import { DataGrid } from "@mui/x-data-grid";

const StyledPaginationContainer = styled("div")({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "10px",
    gap: "16px",
});

const StyledPageInfo = styled("div")({
    color: "#666",
    fontSize: "14px",
});

const StyledDataGrid = styled(DataGrid)({
    border: "none",
    minHeight: "150px",
    "& .MuiDataGrid-columnSeparator": {
        display: "none",
    },
    "& .MuiDataGrid-cell": {
        whiteSpace: "normal",
        wordWrap: "break-word",
        lineHeight: "1.4",
        padding: "8px",
        display: "flex",
        alignItems: "center",
        fontWeight: 400,
        fontSize: "13px",
        color: "#000000de",
    },
    "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
        outline: "none !important",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
        color: "rgb(158, 158, 158)",
        fontSize: "12px",
        fontWeight: 600,
        textTransform: "uppercase",
        textAlign: "left",
    },
});

const CustomDataGrid = ({
    rows,
    columns,
    totalCount,
    page,
    pageSize,
    sortModel,
    onSortModelChange,
    onPageChange,
    rowHeight,
    loading,
    columnVisibilityModel
}) => {
    const totalPages = Math.ceil(totalCount / pageSize);

    return (
        <div>
            <StyledDataGrid
                rows={rows}
                columns={columns}
                sortModel={sortModel}
                onSortModelChange={onSortModelChange}
                rowCount={totalCount}
                paginationMode="server"
                sortingMode="server"
                pageSize={pageSize}
                loading={loading}
                rowHeight={rowHeight}
                hideFooter
                disableColumnMenu
                disableRowSelectionOnClick
                disableColumnSorting={loading}
                columnVisibilityModel={columnVisibilityModel}
                slotProps={{
                    loadingOverlay: { variant: "circular-progress" },
                }}
            />
            <StyledPaginationContainer>
                <Pagination
                    count={totalPages}
                    page={page}
                    onChange={onPageChange}
                    color="primary"
                    showFirstButton
                    showLastButton
                    variant="outlined"
                    shape="rounded"
                />
                <StyledPageInfo>
                    Showing {(page - 1) * pageSize + 1}-{Math.min(page * pageSize, totalCount)} of {totalCount} items
                </StyledPageInfo>
            </StyledPaginationContainer>
        </div>
    );
};

export default CustomDataGrid;
